import { render, staticRenderFns } from "./MigrisWeb.vue?vue&type=template&id=b6f5a490&"
import script from "./MigrisWeb.vue?vue&type=script&lang=js&"
export * from "./MigrisWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports